import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight'
})

export class HighlightTextPipe implements PipeTransform {

    transform(value: string, args: string[]): any {
        if (args && value) {
            value = String(value);
            for (const arg of args) {
                if (arg && arg.trim().length > 0) {
                    const startIndex = value.toLowerCase().indexOf(arg.toLowerCase());
                    if (startIndex !== -1) {
                        // Escape Special Char with '\'
                        const newArg = arg.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
                        const matchingString = new RegExp(newArg, 'gi');
                        const replaceString = value.substr(startIndex, arg.length);
                        value = value.replace(matchingString, '<mark>' + replaceString + '</mark>');
                    }
                }
            }

        }
        return value;
    }
}
